import {getAuthorizationHeader} from "../helpers/get-token";
import {isAuthOptimService} from "./new-user-auth";

const getUserData = async (userId) => {
    const token = getAuthorizationHeader()
    const res = await isAuthOptimService(token)
    return res;
}

export default getUserData;